import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoText from '../../../components/atoms/InfoText';
import FormField from '../../../components/FormField/FormField';

export default function PlanInfoSection() {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col gap-6"
      data-testid="section-plan-information"
    >
      <div className="flex flex-col gap-1.5" data-testid="plan-info-header">
        <InfoText
          text={t('home.plan-information-title')}
          className="text-[20px] !font-bold !text-light-text-primary dark:!text-dark-text-primary !leading-[100%]"
        />
        <InfoText
          text={t('home.plan-information-desc')}
          className="!text-light-text-secondary dark:!text-dark-text-secondary text-[16px] !font-normal leading-normal"
        />
      </div>

      {/* Names: EN and AR (Static - not editable per story) */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div data-testid="field-name-en-container">
          <FormField
            type="text"
            id="nameEn"
            name="nameEn"
            label={t('home.plan-name-en')}
            labelClassName="!text-[16px] !font-semibold !text-light-text-primary dark:!text-dark-text-primary mb-2"
            disabled
            data-testid="field-name-en"
          />
        </div>
        <div data-testid="field-name-ar-container">
          <FormField
            type="text"
            id="nameAr"
            name="nameAr"
            label={t('home.plan-name-ar')}
            labelClassName="!text-[16px] !font-semibold !text-light-text-primary dark:!text-dark-text-primary mb-2"
            disabled
            data-testid="field-name-ar"
          />
        </div>
      </div>

      {/* Product limit */}
      <div data-testid="field-product-limit-container">
        <FormField
          type="number"
          id="productLimit"
          name="productLimit"
          label={t('home.product-limit-label')}
          labelClassName="!text-[16px] !font-semibold !text-light-text-primary dark:!text-dark-text-primary mb-2"
          placeholder={t('home.set-limit-placeholder')}
          required
          min={1}
          data-testid="field-product-limit"
        />
      </div>
    </div>
  );
}
